var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_11304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0H2C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4V23C2 23.37 2.2 23.71 2.53 23.88C2.86 24.05 3.25 24.04 3.56 23.83L6.01 22.2L8.46 23.83C8.8 24.05 9.23 24.05 9.57 23.83L12.02 22.2L14.47 23.83C14.81 24.05 15.24 24.05 15.58 23.83L18.03 22.2L20.48 23.83C20.65 23.94 20.84 24 21.03 24C21.19 24 21.35 23.96 21.5 23.88C21.83 23.71 22.03 23.37 22.03 23V3.93C22.89 3.71 23.53 2.93 23.53 2C23.53 0.9 22.63 0 21.53 0H21.5ZM20 21.13L18.55 20.17C18.21 19.95 17.78 19.95 17.44 20.17L14.99 21.8L12.54 20.17C12.37 20.06 12.18 20 11.99 20C11.8 20 11.6 20.06 11.44 20.17L8.99 21.8L6.54 20.17C6.2 19.95 5.77 19.95 5.43 20.17L3.98 21.13V2H19.98V21.13H20Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6H17C17.55 6 18 5.55 18 5C18 4.45 17.55 4 17 4H7C6.45 4 6 4.45 6 5C6 5.55 6.45 6 7 6Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10H7C6.45 10 6 9.55 6 9C6 8.45 6.45 8 7 8H17C17.55 8 18 8.45 18 9C18 9.55 17.55 10 17 10Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_11304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/Receipt.dc90927a.svg";
export { ForwardRef as ReactComponent };